import { Text } from '$tablet-app/src/app/components/Text/Text';
import { spacing } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { StyleSheet } from 'react-native';

const FieldLabel: FC<{ children?: React.ReactNode }> = (props) => (
  <Text style={styles.label} preset="bold">
    {props.children}
  </Text>
);

// Styles
const styles = StyleSheet.create({
  label: {
    marginBottom: spacing[2],
  },
});

export default FieldLabel;
